




import { Component, Mixins, Vue } from "vue-property-decorator";
import { getState } from "@/apis";
import SettingMixin from "@/mixins/settingMixin";

@Component
export default class Init extends Mixins(Vue, SettingMixin) {
  async mounted(): Promise<void> {
    const queries = window.location.search;
    await getState(this.campaignId)
      .then(async (res) => {
        // 友だち追加画面
        if (this.errorCode === "block") {
          if (window.performance.navigation.type === 1) {
            this.routerPushCampaignPage();
            return;
          }
          history.pushState(
            null,
            "",
            window.location.origin +
              "" +
              window.location.pathname +
              "#/addFriend" +
              `${queries}`
          );
          location.reload();
          return;
        }

        // チャージ画面
        if (this.redirectCode) {
          this.routerPushChargeMyPage();
          return;
        }
        if (this.redirectCodeQueryParamValue) {
          if (window.performance.navigation.type === 1) {
            this.routerPushCampaignPage();
            return;
          }
          history.pushState(
            null,
            "",
            window.location.origin +
              "" +
              window.location.pathname +
              "#/myPage" +
              `${queries}`
          );
          location.reload();
          return;
        }
        // 応募画面 期間外画面
        if (res.data.state === "teaser") {
          this.routerPushExpiredPage("teaser");
          return;
        } else if (res.data.state === "closed") {
          this.routerPushExpiredPage("closed");
          return;
        } else if (res.data.state === "maintenance") {
          this.routerPushExpiredPage("teaser");
          return;
        } else {
          if (this.serialCode) {
            this.routerPushCampaignPage(this.serialCode);
            return;
          }
          history.pushState(
            null,
            "",
            window.location.origin +
              "" +
              window.location.pathname +
              "#/campaign" +
              `${queries}`
          );
          location.reload();
          return;
        }
      })
      .catch(() => {
        this.routerPushSystemErrorPage();
      });
  }
}
